import React, { useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import _ from "lodash";
import StyledAppBar from "./StyledAppBar";
import Sidebar from "./Sidebar";
import { TranslaterContext } from "../../../providers/TranslaterProvider";
import useCartCount from "../../../hooks/useCartCount";
import { useLocation } from "@reach/router";
import useUser from "../../../hooks/useUser";
import CaseService from "../../../services/CaseService";
import useLoader from "../../../hooks/useLoader";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    width: "100vw",
    overflow: "hidden",
  },
  content: {
    flexGrow: 1,
    marginTop: 74,
    transition: "margin-left 0.3s ease",
  },
}));

export function Header({
  children,
  showSidebar = false,
  selectedItem,
  NavPages = false,
  hideLinks = false,
  LandingPage = false,
  selectedSubItem = "",
}) {
  const classes = useStyles();
  const { userObject } = useUser();
  const { translaterOpen } = useContext(TranslaterContext);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const { triggerCount, setTriggerCount, setStats, stats } = useCartCount();
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const toggleSidebar = () => setSidebarOpen((prev) => !prev);
  const { showDrawer, setShowDrawer } = useLoader();

  useEffect(() => {
    if (!_.isEmpty(userObject) && triggerCount) {
      CaseService.caseStats("").then(
        (res) => {
          setStats(res);
        },
        (err) => {
          console.log(err);
          setTriggerCount(false);
        },
      );
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userObject, triggerCount]);

  useEffect(() => {
    localStorage.setItem("Collapse", showDrawer);
  }, [showDrawer]);

  return (
    <div className={classes.root}>
      <CssBaseline />

      {/* Pass toggle + state down to AppBar */}
      <StyledAppBar
        NavPages={NavPages}
        hideLinks={hideLinks}
        LandingPage={LandingPage}
        onToggleSidebar={toggleSidebar}
        sidebarOpen={sidebarOpen}
        {...{
          showDrawer,
          setShowDrawer,
        }}
      />

      {/* Conditionally render sidebar based on toggle */}
      {showSidebar && sidebarOpen && (
        <Sidebar
          {...{
            selectedItem, stats, selectedSubItem, showDrawer,
            setShowDrawer,
          }}
          selectedSubItem={
            searchParams.get("caseType")
              ? searchParams.get("caseType")
              : selectedSubItem
          }
        />
      )}

      <main
        className={classes.content}
        style={translaterOpen ? { marginTop: "40px" } : {}}
      >
        {children}
      </main>
    </div>
  );
}
